import ServiceCategoryPage from "../components/ServiceCategoryPage";
import plumberService from "../data/services/plumberService";

function Plumber() {
  return <ServiceCategoryPage service={plumberService} />;
}

export default Plumber;